const SystemConfiguration = () => import("./SystemConfiguration.vue");

export const systemConfigurationRoutes = [
  {
    path: "/admin/system-configuration",
    name: "AdminSystemConfiguration",
    component: SystemConfiguration,
  },
];
